"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
const KEY_F2 = 113;
const KEY_ENTER = 13;
const KEY_TAB = 9;
const MultiSelectCellEditorReact = (0, react_1.forwardRef)((props, ref) => {
    const createInitialState = () => {
        let startValue;
        let highlightAllOnFocus = true;
        if (props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE) {
            // if backspace or delete pressed, we clear the cell
            startValue = '';
        }
        else if (props.charPress) {
            // if a letter was pressed, we start with the letter
            // startValue = props.charPress;
            // highlightAllOnFocus = false;
        }
        else {
            // otherwise we start with the current value
            startValue = props.value;
            if (props.keyPress === KEY_F2) {
                highlightAllOnFocus = false;
            }
        }
        return {
            value: startValue,
            highlightAllOnFocus
        };
    };
    const initialState = createInitialState();
    const [value, setValue] = (0, react_1.useState)(initialState.value);
    const [opened, setOpened] = (0, react_1.useState)(false);
    const [highlightAllOnFocus, setHighlightAllOnFocus] = (0, react_1.useState)(initialState.highlightAllOnFocus);
    const refInput = (0, react_1.useRef)(null);
    const isLeftOrRight = event => {
        return [37, 39].indexOf(event.keyCode) > -1;
    };
    const getCharCodeFromEvent = event => {
        event = event || window.event;
        return (typeof event.which === "undefined") ? event.keyCode : event.which;
    };
    const deleteOrBackspace = event => {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
    };
    const finishedEditingPressed = event => {
        const charCode = getCharCodeFromEvent(event);
        return charCode === KEY_ENTER || charCode === KEY_TAB;
    };
    const onKeyDown = event => {
        if (isLeftOrRight(event) || deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [onKeyDown]);
    (0, react_1.useImperativeHandle)(ref, () => {
        return {
            afterGuiAttached() {
                // get ref from React component
                const eInput = refInput.current;
                eInput.focus();
                // eInput.addEventListener('keydown', onKeyDown);
                if (highlightAllOnFocus) {
                    // eInput.select();
                    setHighlightAllOnFocus(false);
                }
                else {
                    // when we started editing, we want the carot at the end, not the start.
                    // comes into play in two scenarios: a) when user hits F2 and b)
                    // when user hits a printable character, then on IE (and only IE) the carot
                    // was placed after the first character, thus 'apply' would end up as 'pplea'
                    // const length = eInput.value ? eInput.value.length : 0;
                    if (length > 0) {
                        // eInput.setSelectionRange(length, length);
                    }
                }
            },
            getValue() {
                return value;
            },
            isPopup() {
                return true;
            }
        };
    });
    const updateValue = (value) => {
        if (value) {
            const values = value.map(v => v.value).join('; ');
            setValue(values);
            return;
        }
        setValue(null);
    };
    const defaultValue = () => {
        const initValue = initialState.value || '';
        return initValue.split(';').map(value => value.trim()).filter(value => value !== "").map(value => ({ value }));
    };
    return (react_1.default.createElement("div", { className: "ag-cell-editor" },
        react_1.default.createElement("div", { className: "ag-input-wrapper ag-text-field-input-wrapper ag-wrapper w-72", role: "presentation" },
            react_1.default.createElement(react_select_1.default, { ref: refInput, closeMenuOnSelect: false, hideSelectedOptions: false, onMenuOpen: () => setOpened(true), onMenuClose: () => setOpened(false), defaultValue: defaultValue(), onChange: updateValue, options: props.values.map((value) => ({ value: value })), getOptionValue: (option) => option.value, getOptionLabel: (option) => option.value, isMulti: true, className: "w-full" }))));
});
exports.default = MultiSelectCellEditorReact;
